import _defineProperty from "/var/jenkins/workspace/Consolidated/Code/Dev/Web@2/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/var/jenkins/workspace/Consolidated/Code/Dev/Web@2/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins/workspace/Consolidated/Code/Dev/Web@2/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/var/jenkins/workspace/Consolidated/Code/Dev/Web@2/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/jenkins/workspace/Consolidated/Code/Dev/Web@2/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/var/jenkins/workspace/Consolidated/Code/Dev/Web@2/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { Component } from 'react';
import { connect } from 'react-redux';
import TimestampManager from '../../utils/TimestampManager';
import QueryParamsProxy from '../../utils/queryParamProxy';
import RouteParamConstants from '../../utils/routeParamConstants';
import { setVideosAdsInfo as _setVideosAdsInfo } from '../../state/actions/extras';
var WatchAndEarnInfo = /*#__PURE__*/function (_Component) {
  function WatchAndEarnInfo() {
    var _this;
    _classCallCheck(this, WatchAndEarnInfo);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, WatchAndEarnInfo, [].concat(args));
    _this.state = {};
    _this.videoAdsTimer = undefined;
    return _this;
  }
  _inherits(WatchAndEarnInfo, _Component);
  return _createClass(WatchAndEarnInfo, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.videoAds && this.props.videoAds.secondsUntilReset > 0) {
        this.videoAdsTimer = TimestampManager.register(this.props.videoAds.secondsUntilReset * 1000, function () {
          QueryParamsProxy.setQueryParams(_defineProperty({}, RouteParamConstants.PARAM_MODAL, undefined));
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      TimestampManager.unregister(this.videoAdsTimer);
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.render(_objectSpread({}, this.props));
    }
  }]);
}(Component);
var mapStateToProps = function mapStateToProps(state) {
  return {
    videoAds: state.videoAds
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    setVideosAdsInfo: function setVideosAdsInfo(value) {
      dispatch(_setVideosAdsInfo(value));
    }
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(WatchAndEarnInfo);